import { Badge } from '@chakra-ui/react';
import React from 'react';

import { FundingRequestStatusEnumGQLType } from 'types/dashboard-core-gqlTypes.generated';

export const statusConfigs: Record<
  FundingRequestStatusEnumGQLType,
  { bg: string; color: string; label: string }
> = {
  approved: {
    bg: 'green.100',
    color: 'green.400',
    label: 'Approved',
  },
  submitted: {
    bg: 'blue.100',
    color: 'blue.400',
    label: 'Submitted',
  },
  pending: {
    bg: 'gray.100',
    color: 'gray.900',
    label: 'Pending',
  },
  canceled: {
    bg: 'gray.100',
    color: 'gray.900',
    label: 'Canceled',
  },
  unsubmitted: {
    bg: 'gray.100',
    color: 'gray.900',
    label: 'Unsubmitted',
  },
  expired: { bg: 'red.100', color: 'red.400', label: 'Expired' },
  rejected: {
    bg: 'red.100',
    color: 'red.400',
    label: 'Rejected',
  },
};

export const StatusBadge = ({
  value,
}: {
  value: FundingRequestStatusEnumGQLType;
}) => {
  const { bg, color, label } = statusConfigs[value];
  return (
    <Badge
      variant="subtle"
      padding="5px 10px"
      width="110px"
      height="30px"
      textAlign="center"
      bg={bg}
      color={color}
    >
      {label}
    </Badge>
  );
};
